<button
  type="submit"
  class="bo-auth-submit"
  [class.bo-auth-submit--secondary]="variant() === 'secondary'"
  [class.bo-auth-submit--gradient]="variant() === 'gradient'"
  [class.bo-auth-submit--loading]="loading()"
  [class.bo-auth-submit--disabled]="disabled()"
  [disabled]="loading() || disabled()"
  [attr.aria-busy]="loading() || undefined"
  [attr.aria-disabled]="disabled() || undefined"
>
  @if (loading()) {
    <span class="bo-auth-submit__spinner" aria-hidden="true"></span>
  }
  <ng-content select="[btn-icon]"></ng-content>
  <span class="bo-auth-submit__label">{{ displayLabel() }}</span>
</button>
